// GTM dataLayer wrappers. React's synthetic event system swallows the native
// `submit` events that GTM's auto Form Submission trigger relies on, so any
// form-submit conversion has to push manually here.

interface DataLayerEvent {
  event: string;
  [key: string]: unknown;
}

declare global {
  interface Window {
    dataLayer?: DataLayerEvent[];
  }
}

export function pushDataLayer(event: DataLayerEvent): void {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(event);
}

export function trackFormSubmission(params: {
  formName: string;
  homeInterest?: string;
}): void {
  pushDataLayer({
    event: "form_submission",
    form_name: params.formName,
    home_interest: params.homeInterest || null,
  });
}
